
import Vue from "vue";
import Component from "vue-class-component";
import NavBread from "./component/NavBread.vue";
import FeedbackEntranceComponent from "./component/FeedbackEntranceCompnent.vue";
import { zoomElement } from "../../nmb/util";

@Component({
  components: { NavBread, FeedbackEntranceComponent }
})
export default class FeedbackEntrance extends Vue {
  navData: any = [
    { name: "反馈中心", to: { path: "/feedback" } },
    { name: "我要反馈" }
  ];
  zoom() {
    return zoomElement();
  }
}
